export default __webpack_public_path__ + "static/media/logo_bright.803d5054.png";